import React, {useEffect, useState} from "react";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import Detail from "../../components/common/detail/Detail";
import {getValidatedLimit} from "../../components/Utility";
import {fetchCustomerById} from "../../store/customer-slice";
import {getDetailData} from "../../models/customerModel";
import Button from "../../components/common/button/Button";
import {fetchCustomersWithDiscount} from "../../store/customer-discount-slice";

const CustomerDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const [isDiscountEdit, setIsDiscountEdit] = useState('');
    const {pagination} = useSelector(state => state.customer);
    const {items: customersWithDiscount} = useSelector(state => state.discount)
    const {limit, currentPage} = getValidatedLimit(pagination);
    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchCustomerById({...userRole, id: params.customerId}));
    }, [dispatch, params.customerId, userRole]);


    useEffect(() => {
        dispatch(fetchCustomersWithDiscount({...userRole}))
    }, [dispatch, userRole])

    useEffect(() => {
        if (customersWithDiscount && params.customerId) {
            const matchedCustomer = customersWithDiscount.find(
                (item) => item.customer?._id === params.customerId
            );

            if (matchedCustomer) {
                setIsDiscountEdit(matchedCustomer._id);
            } else {
                setIsDiscountEdit('');
            }
        }
    }, [customersWithDiscount, params.customerId]);


    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector((state) => state.customer);

    const item = items.find(item => item.id === params.customerId);
    const detailData = getDetailData({item});

    return (
        <>
            <SubHeader title="Customer Details">
                {isDiscountEdit ?
                    <Button to={`editDiscount/${isDiscountEdit}`} className="btn-sm bg-primary bg-opacity-50">Edit
                        Discount</Button> :
                    <Button to="addDiscount" className="btn-sm bg-primary bg-opacity-50">Add Discount</Button>}


                <Button to={`../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>}
            </div>
        </>
    );
}
export default CustomerDetail;

